import { type ObjectValuesUnionType } from '../../../utils/typing';
import { type GRRoundUserStatus } from '../types/user';

import { type GRRoundBetsBetState } from './chip';

export const GRRounds = Object.freeze({
  SHOE: 'SHOE',
  BALLOON: 'BALLOON',
  SHIRT: 'SHIRT',
});
export type GRRound = ObjectValuesUnionType<typeof GRRounds>;

export const ObfGRRounds = Object.freeze({
  [GRRounds.SHOE]: 1,
  [GRRounds.BALLOON]: 2,
  [GRRounds.SHIRT]: 3,
});

export const ReverseObfGRRounds = Object.freeze({
  '1': GRRounds.SHOE,
  '2': GRRounds.BALLOON,
  '3': GRRounds.SHIRT,
});

export type GRRoundState = {
  status: GRRoundUserStatus;
  wonAmount: number | null;
  points: number | null;
  bets: Array<GRRoundBetsBetState>;
};
